/* <kompozit-emblem>: hero emblem (home-hero-card). Depth effect by Atropos (assets/atropos.min.js, MIT):
   the emblem floats over its own blurred shadow copy and tilts after the cursor / finger.
   SVG emblem (snippets/kz-emblem-svg): while the pointer is over it the four petals move apart from the centre
   and shift after the pointer, each with its own strength.
   No motion with prefers-reduced-motion; without JS or Atropos it is a static picture. */
(() => {
  if (customElements.get('kompozit-emblem')) return;

  class KompozitEmblem extends HTMLElement {
    connectedCallback() {
      this.ac?.abort();
      this.ac = new AbortController();
      const rm = matchMedia('(prefers-reduced-motion: reduce)');
      // petal: [x direction, y direction, strength]; offsets are in SVG user units (viewBox 960)
      const PETALS = { purple: [-1, -1, 1], green: [1, -1, 0.7], orange: [-1, 1, 0.8], blue: [1, 1, 1.15] };
      const svg = this.querySelector('.kz-em__svg');
      const petals = svg ? [...svg.querySelectorAll('.kz-em__petal')] : [];
      const rest = () => petals.forEach((p) => { p.style.transform = ''; });
      const spread = (e) => {
        if (rm.matches || !petals.length) return;
        const r = svg.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
        const y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
        petals.forEach((p) => {
          const [dx, dy, k] = PETALS[p.dataset.petal] || [0, 0, 0];
          p.style.transform = `translate(${(dx * 14 + x * 22 * k).toFixed(1)}px, ${(dy * 14 + y * 22 * k).toFixed(1)}px)`;
        });
      };
      const o = { signal: this.ac.signal };
      this.addEventListener('pointermove', spread, { ...o, passive: true });
      this.addEventListener('pointerleave', rest, o);
      this.addEventListener('pointercancel', rest, o);
      this.addEventListener('pointerup', (e) => { if (e.pointerType !== 'mouse') rest(); }, o);

      const sync = () => {
        this.atropos?.destroy();
        this.atropos = null;
        if (rm.matches) rest();
        const el = this.querySelector('.atropos');
        if (!el || rm.matches || typeof window.Atropos !== 'function') return;
        this.atropos = window.Atropos({
          el,
          activeOffset: 30,
          shadow: false,
          highlight: false,
          rotateXMax: 14,
          rotateYMax: 14,
          rotateTouch: 'scroll-y',
        });
      };
      rm.addEventListener('change', sync, { signal: this.ac.signal });
      sync();
    }

    disconnectedCallback() {
      this.ac?.abort();
      this.atropos?.destroy();
      this.atropos = null;
    }
  }
  customElements.define('kompozit-emblem', KompozitEmblem);
})();
